'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFileWordO = function FaFileWordO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-26.2-20v2.4h1.6l3.6 14.8h3.6l2.8-10.8q0.2-0.5 0.3-1.1 0-0.3 0-0.5h0.1l0.1 0.5q0 0.1 0 0.5t0.2 0.6l2.8 10.8h3.6l3.6-14.8h1.6v-2.4h-6.7v2.4h2l-2.2 9.8q-0.1 0.5-0.2 1l0 0.5h-0.1l-0.1-0.5q0-0.1-0.1-0.4t-0.1-0.6l-3.2-12.2h-2.5l-3.2 12.2q-0.1 0.2-0.1 0.6t-0.1 0.4l-0.1 0.5h-0.1l0-0.5q-0.1-0.5-0.2-1l-2.2-9.8h2v-2.4h-6.7z' })
        )
    );
};

exports.default = FaFileWordO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/file-word-o.js
// module id = 1465
// module chunks = 0